import { ButtonVariant, CoButton } from "components/CoButton";
import useLabels from "hooks/useLabels";
import { PaperAccessButtonProps } from "./types";

/**
 * UploadPdfButton is a button that opens the upload PDF modal
 */
const UploadPdfButton: React.FC<PaperAccessButtonProps> = () => {
  // TODO(Aakash): Implement upload PDF functionality - this should open the upload PDF modal
  const [labels] = useLabels("paper-access-button");
  return (
    <CoButton
      variant={ButtonVariant.Tertiary}
      label={labels["upload-pdf"]}
      icon="icon-upload-pdf"
      size="sm"
      disabled
    />
  );
};

export default UploadPdfButton;
